import { IApiConfig } from "../Contracts/IApiConfig";

const hostname = window && window.location && window.location.hostname;
const app_Root = {} as IApiConfig;

if (hostname.indexOf("localhost") > -1) {
 
 

   app_Root.backendHost ="https://localhost:44385/api";  

  
 
 

} else {
   
 

 

app_Root.backendHost ="https://api.cimmple.net/api";  


 
}

export const API_ROOT = app_Root;
